import type { DesignFile } from "./types";

export const IMAGE_EXTENSIONS = new Set(["jpeg", "jpg", "png", "webp"]);

export function isImageDesign(design: DesignFile): boolean {
  return IMAGE_EXTENSIONS.has(design.extension.toLowerCase());
}
